import { get_office_usage } from '../../api';
import { useApi } from '../../use_api';
import { consumed_pct, fmt_cycle_window, fmt_pct, pct, status_of, usage_status_color } from './format';

function Bar({ label, used, limit, over }: { label: string; used: number; limit: number; over: boolean }) {
  const raw = pct(used, limit);
  const width = Math.min(100, raw);
  const color = over || raw >= 100 ? '#b3261e' : raw >= 80 ? '#b58900' : 'var(--green-700)';
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
        <span>{label}</span>
        <span className="muted">
          {used.toLocaleString()} / {limit.toLocaleString()} ({fmt_pct(raw)})
        </span>
      </div>
      <div style={{ height: 8, background: 'var(--green-50)', borderRadius: 999, overflow: 'hidden', marginTop: 4 }}>
        <div style={{ width: `${width}%`, height: '100%', background: color }} />
      </div>
    </div>
  );
}

export function UsageView() {
  const { loading, data, error } = useApi(() => get_office_usage(), []);

  if (loading) return <p className="muted">Loading usage…</p>;
  if (error) return <p className="error">Couldn’t load usage.</p>;

  const u = data?.usage;
  if (!u) {
    return (
      <div className="card">
        <p className="muted" style={{ margin: 0 }}>No usage recorded for this billing cycle yet.</p>
      </div>
    );
  }

  const st = status_of(u);
  return (
    <div className="card" style={{ maxWidth: 560 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Usage</h2>
        <span style={{ color: usage_status_color(st), fontWeight: 600, textTransform: 'uppercase', fontSize: 12 }}>
          {st}
        </span>
      </div>
      <p className="muted" style={{ marginTop: 4 }}>
        {u.plan_tier} plan · {fmt_cycle_window(u.cycle)} · {u.days_remaining} day{u.days_remaining === 1 ? '' : 's'} left
      </p>
      <div style={{ marginTop: 12 }} aria-label={`consumed ${fmt_pct(consumed_pct(u))}`}>
        <Bar label="Minutes" used={u.used.minutes} limit={u.limits.minutes} over={u.over_minutes} />
        <Bar label="Messages" used={u.used.messages} limit={u.limits.messages} over={u.over_messages} />
      </div>
    </div>
  );
}
